var map; // マップオブジェクト
var dealer_data; // ディーラーリスト jsonから読み込み
var markers = []; // マーカー
var lanLngMinMax = {latMin: 90,
  latMax: -90,
  lngMin: 180,
  lngMax: -180
};
var currentInfoWindow;
var dropFlag = false;

// 地図の色はリニューアル前をとりあえずそのまま流用
var stylez = [
  {
    'featureType': 'all',
    'stylers': [
      { 'saturation': -100 }
    ]
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      { hue: '#00ffee' },
      { saturation: 50 }
    ]
  }, {
    featureType: 'poi.business',
    elementType: 'labels',
    stylers: [
      { visibility: 'off' }
    ]
  }, {
    'featureType': 'water',
    'stylers': [
      { 'color': '#C8D0DB' }
    ]
  }
];

var myPosition;

function initMap () {
  map = new google.maps.Map(document.getElementById('dealer-map'), {
    center: {lat: 35.6679191, lng: 139.4606805},
    zoom: 7,
    mapTypeControl: false, // マップタイプ コントロール
    fullscreenControl: false, // 全画面表示コントロール
    streetViewControl: false, // ストリートビュー コントロール
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP
    },
    maxZoom: 16,
    minZoom: 5,
    styles: stylez
  });

  google.maps.event.addListener(map, 'zoom_changed', function () {
    if (map.getZoom() > 8 && !dropFlag) {
      drop();
      dropFlag = true;
    }
  });
}

function drop () {
  clearMarkers();
  var j = 0;
  for (var i = 0; i < dealer_data.length; i++) {
    if (dealer_data[i].selected) {
      addMarkerWithTimeout(dealer_data[i], j * 10);
      j++;
    }
  }
}

function addMarkerWithTimeout (data, timeout) {
  var position = {lat: data.lat, lng: data.lng};
  window.setTimeout(function () {
    var myMarker = new google.maps.Marker({
      position: position,
      map: map,
      title: data.name,
      clickable: true,
      animation: google.maps.Animation.DROP,
      icon: {
        url: '/dealer/image/icon-mapmarker@2x.png',
        size: new google.maps.Size(40, 47),
        scaledSize: new google.maps.Size(40, 47)
      }
    });
    markers.push(myMarker);
    setInfoWin(myMarker, data);
  }, timeout);
}

function setInfoWin (marker, data) {
  var infowindow = new google.maps.InfoWindow();
  var infoContent = '<div class="dealer-info-cover js-dealer-info-cover">';
  if (!data.company) {
    infoContent += '<p class="dealer-info-title"><a href="' + data.url + '" target="_blank">' + data.name + '</a><p>';
  } else {
    infoContent += '<p class="dealer-info-title dealer-info-title-service">' + data.name + '<br>' + data.company + '</p>';
  }
  if (!data.isClosed) {
    infoContent += '<div class="dealer-info-address"><p class="dealer-info-address-address">〒' + data.zip + ' ' + data.address + '</p><p class="dealer-info-address-tel"><svg xmlns="http://www.w3.org/2000/svg" width="12.975" height="12.975" viewBox="0 0 12.975 12.975" class="dealer-info-address-tel-icon"><path d="M12.975 9.673v2.549a.721.721 0 01-.67.719c-.315.022-.572.033-.771.033A11.533 11.533 0 010 1.442q0-.3.033-.771A.721.721 0 01.753 0H3.3a.361.361 0 01.359.324c.017.166.032.3.046.4a10.024 10.024 0 00.871 2.884.328.328 0 01-.106.409L2.916 5.126a9.4 9.4 0 004.933 4.933l1.11-1.553a.333.333 0 01.413-.107 10.022 10.022 0 002.883.869c.1.014.232.03.4.046a.36.36 0 01.324.359z"/></svg>' + data.tel + '</div>';

    infoContent += '<div class="dealer-info-dateinfo"><p>';
    if (data.holiday) {
      infoContent += '定休日：' + data.holiday;
    }
    if (data.businesshours) {
      infoContent += '<br>営業時間：' + data.businesshours;
    }
    infoContent += '</p>';
    if (data.notice) {
      if (data.noticeTimer) {
        var beforeDate = new Date(data.noticeTimer.before),
          afterDate = new Date(data.noticeTimer.after),
          visibleDate = new Date(data.noticeTimer),
          today = new Date();
        if (data.noticeTimer.before && today <= beforeDate) {
          infoContent += '<p class="dealer-info-notice">' + data.notice.before + '</p>';
        } else if (data.noticeTimer.before && today > beforeDate && data.noticeTimer.after && today <= afterDate) {
          infoContent += '<p class="dealer-info-notice">' + data.notice.after + '</p>';
        } else if (data.notiveTimer && today <= visibleDate) {
          infoContent += '<p class="dealer-info-notice">' + data.notice + '</p>';
        }
      }
    }
    infoContent += '</div>';
  } else {
    infoContent += '<div class="dealer-info-dateinfo"><p>'+data.isClosed+'をもちまして閉店いたしました。</p></div>'
  }
  if (!data.company) {
    infoContent += '<div class="dealer-info-btns">';
    infoContent += '<div class="dealer-info-btns-icons"><ul>';
    if (data.expresslane) {
    } else if (data.awardeddealer) {
      infoContent += '<li><img src="/dealer/image/icon-2023-awarded-dealer.png" alt="Autoexpert 認定中古車"></li>';
    } else if (data.expertcenter) {
      infoContent += '<li><img src="/dealer/image/icon-expertcenter-s@2x.png" alt="Expertcenter"></li>';
    } else if (data.bestdealer) {
      infoContent += '<li><img src="/dealer/image/icon-2023-best-dealer.png" alt="BEST DEALER"></li>';
    } else if (data.expresslane) {
      infoContent += '<li><img src="/dealer/image/icon-expresslane@2x.png" alt="EXPRESSLANE"></li>';
    }
    infoContent += '</ul></div>';

    infoContent += '<div class="dealer-info-btns-left"><a href="' + data.url + '" target="_blank"><p class="dealer-info-btns-button"><span>VIEW MORE<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g id="icon-newwindow" transform="translate(0 0)"><path id="" data-name="" d="M-3433-412h-1v-12h5v1h-4v10h10v-4h1v5Zm5.672-7.378,3.623-3.622H-3427v-1h5v5h-1v-3.293l-3.622,3.622Z" transform="translate(3434 424)" /></g></svg></span><i></i></p></a></div></div>';
  } else {
    infoContent += '<div class="dealer-info-note"><ul>';
    if (data.noteTestdrive) {
      infoContent += '<li>※試乗および新車の販売は行っておりません。</li>';
    }
    if (data.noteGulliastelvio) {
      infoContent += '<li>※GIULIA / STELVIOのサービスは行っておりません。</li>';
    }
    infoContent += '</ul></div>';
  }

  infoContent += '</div>';

  google.maps.event.addListener(marker, 'click', function (e) {
    map.setZoom(15);
    map.panTo(marker.position);
    if (currentInfoWindow) {
      currentInfoWindow.close();
    }
    infowindow.setContent(infoContent);
    infowindow.open(map, marker);
    currentInfoWindow = infowindow;
  });
}

function clearMarkers () {
  for (var i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }
  markers = [];
}

function setLatLngMinMax () {
  lanLngMinMax = {latMin: 90,
    latMax: -90,
    lngMin: 180,
    lngMax: -180
  };
  for (var i = 0; i < dealer_data.length; i++) {
    if (dealer_data[i].selected) {
      lanLngMinMax.latMin = Math.min(lanLngMinMax.latMin, dealer_data[i].lat);
      lanLngMinMax.latMax = Math.max(lanLngMinMax.latMax, dealer_data[i].lat);
      lanLngMinMax.lngMin = Math.min(lanLngMinMax.lngMin, dealer_data[i].lng);
      lanLngMinMax.lngMax = Math.max(lanLngMinMax.lngMax, dealer_data[i].lng);
    }
  }
  var min = new google.maps.LatLng(lanLngMinMax.latMin, lanLngMinMax.lngMin);
  var max = new google.maps.LatLng(lanLngMinMax.latMax, lanLngMinMax.lngMax);
  var latLngBounds = new google.maps.LatLngBounds(min, max);
  map.fitBounds(latLngBounds);
}

jQuery(document).ready(function ($) {
  var url = 'js/dealer_info.json';
  var checkNoData = false;
  $.getJSON(
    url,
    function (data) {
      dealer_data = data;
      for (var m in dealer_data) {
        dealer_data[m].lat = parseFloat(dealer_data[m].lat);
        dealer_data[m].lng = parseFloat(dealer_data[m].lng);
        dealer_data[m].selected = true;
      }
      setLatLngMinMax();
    }
  );

  // 都道府県セレクト時
  $(document).on('change', '.js-mapform-prefectureslist', function () {
    searchDealer();

    var checkDisabled = {
      dealer: false,
      secondhandcar: false,
      servicenetwork: false

    };
    if ($('.js-mapform-prefectureslist').val() === 'all') {
      checkDisabled = {
        dealer: true,
        secondhandcar: true,
        servicenetwork: true

      };
      $('.dealer-list > section').show();
    } else {
      $('.dealer-list > section').hide();
      $('.dealer-list > section[data-prefectures="' + $('.js-mapform-prefectureslist').val() + '"]').show();
      for (var i = 0; i < dealer_data.length; i++) {
        if ($('.js-mapform-prefectureslist').val() === dealer_data[i].prefectures) {
          checkDisabled.dealer = checkDisabled.dealer || dealer_data[i].company == '' && !dealer_data[i].secondhandcar;

          checkDisabled.secondhandcar = checkDisabled.secondhandcar || dealer_data[i].secondhandcar == true;

          checkDisabled.servicenetwork = checkDisabled.servicenetwork || dealer_data[i].company != '';
        }
      }
    }
    if (checkDisabled.dealer) {
      $('.js-mapform-cb-dealer').prop('disabled', false);
    } else {
      $('.js-mapform-cb-dealer').prop('disabled', true);
    }
    if (checkDisabled.secondhandcar) {
      $('.js-mapform-cb-secondhandcar').prop('disabled', false);
    } else {
      $('.js-mapform-cb-secondhandcar').prop('disabled', true);
    }
    if (checkDisabled.servicenetwork) {
      $('.js-mapform-cb-servicenetwork').prop('disabled', false);
    } else {
      $('.js-mapform-cb-servicenetwork').prop('disabled', true);
    }
  });

  function searchDealer () {
    checkNoData = false;
    if ($('.js-mapform-prefectureslist').val() === 'all') {
      for (var i = 0; i < dealer_data.length; i++) {
        dealer_data[i].selected = true;
        checkcheckbox(dealer_data[i]);
        checkNoData = checkNoData || dealer_data[i].selected;
      }
      $('.js-mapform-cb-dealer').prop('disabled', false);
      $('.js-mapform-cb-secondhandcar').prop('disabled', false);
      $('.js-mapform-cb-servicenetwork').prop('disabled', false);
    } else {
      for (var j = 0; j < dealer_data.length; j++) {
        if ($('.js-mapform-prefectureslist').val() === dealer_data[j].prefectures) {
          dealer_data[j].selected = true;
          checkcheckbox(dealer_data[j]);
        } else {
          dealer_data[j].selected = false;
        }
        checkNoData = checkNoData || dealer_data[j].selected;
      }
    }
    if (checkNoData) {
      drop();
      setLatLngMinMax();
    }
  }

  function checkcheckbox (dealer) {
    if (!$('.js-mapform-cb-dealer').prop('checked') && dealer.company == '' && !dealer.secondhandcar) {
      dealer.selected = false;
    }
    if (!$('.js-mapform-cb-secondhandcar').prop('checked') && dealer.secondhandcar) {
      dealer.selected = false;
    }
    if (!$('.js-mapform-cb-servicenetwork').prop('checked') && dealer.company != '') {
      dealer.selected = false;
    }
  }

  // ボタンチェックボックス操作時
  $('.js-mapform-cb-dealer').on('change', function () {
    searchDealer();
    if (!checkNoData) {
      $(this).prop('checked', true);
    }
  });
  $('.js-mapform-cb-secondhandcar').on('change', function () {
    searchDealer();
    if (!checkNoData) {
      $(this).prop('checked', true);
    }
  });
  $('.js-mapform-cb-servicenetwork').on('change', function () {
    searchDealer();
    if (!checkNoData) {
      $(this).prop('checked', true);
    }
  });
  $('.js-mapform-reset').on('click', function () {
    for (var i = 0; i < dealer_data.length; i++) {
      dealer_data[i].selected = true;
    }
    $('.js-mapform-cb-dealer').prop('disabled', false);
    $('.js-mapform-cb-secondhandcar').prop('disabled', false);
    $('.js-mapform-cb-servicenetwork').prop('disabled', false);
    $('.dealer-list > section').show();
    drop();
    setLatLngMinMax();
    $('html,body').animate({
      scrollTop: $('#jump-delaerlist').offset().top
    }, 400 , 'swing');
    return false;
  });

  // 現在地の取得〜
  var geolocatBox = $('.js-dealer-map-getlocation-cover');
  if (!navigator.geolocation) {
    geolocatBox.hide();
  }
  geolocatBox[0].index = 1;
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(geolocatBox[0]);
  $('#js-mapform-getlocation').on('click', function () {
    if (myPosition) {
      searchNearby(myPosition);
    } else {
      $('.dealer-map-loading').fadeIn(400);
      navigator.geolocation.getCurrentPosition(
        // 取得成功した場合
        function (position) {
          myPosition = position;
          searchNearby(myPosition);
          $('.dealer-map-loading').fadeOut(400);
        },
        // 取得失敗した場合
        function (error) {
          $('.dealer-map-loading').fadeOut(400);
          $('.js-dealer-map-messagebox a').on('click', function () {
            $('.js-dealer-map-messagebox').fadeOut(400);
          });
          $('.js-dealer-map-messagebox').fadeIn(400);
          switch (error.code) {
            case 1: // PERMISSION_DENIED
              $('.js-dealer-map-messagebox span').html('位置情報の利用が許可されていません');
              break;
            case 2: // POSITION_UNAVAILABLE
              $('.js-dealer-map-messagebox span').html('現在位置が取得できませんでした');
              break;
            case 3: // TIMEOUT
              $('.js-dealer-map-messagebox span').html('タイムアウトになりました');
              break;
            default:
              $('.js-dealer-map-messagebox span').html('その他のエラー(エラーコード:' + error.code + ')');
              break;
          }
        }
      );
    }
    $('.dealer-list > section').show();
  });

  // 現在地から一番近いディーラーをチョイス
  function searchNearby (myPos) {
    var nearDist;
    var tempDealer;
    var nearbyDealerHTML = '';
    $('.nearby-dealer-list-subtitle').html('お近くのディーラー');
    $('.nearby-dealer-err-msg').html('');
    for (var i = 0; i < dealer_data.length; i++) {
      dealer_data[i].selected = true;
      var distance = measureDistance(myPos.coords.latitude, myPos.coords.longitude, dealer_data[i].lat, dealer_data[i].lng);
      dealer_data[i]['distance'] = distance;
      if (nearDist) {
        if (nearDist > Math.pow((myPos.coords.latitude - dealer_data[i].lat), 2) + Math.pow((myPos.coords.longitude - dealer_data[i].lng), 2)) {
          nearDist = Math.pow((myPos.coords.latitude - dealer_data[i].lat), 2) + Math.pow((myPos.coords.longitude - dealer_data[i].lng), 2);
          tempDealer = tempDealer = dealer_data[i];
        }
      } else {
        nearDist = Math.pow((myPos.coords.latitude - dealer_data[i].lat), 2) + Math.pow((myPos.coords.longitude - dealer_data[i].lng), 2);
        tempDealer = dealer_data[i];
      }

      if (distance <= 100) {
        nearbyDealerHTML += '<div class="nearby-dealer-card">';
        nearbyDealerHTML += '<h1 class="nearby-dealer-name">' + tempDealer.name + '</h1>';
        nearbyDealerHTML += '<p class="nearby-dealer-company"><span class="km-box">' + tempDealer.distance.toFixed(2) + 'KM</span></p>';
        nearbyDealerHTML += '<div class="nearby-dealer-address">';
        nearbyDealerHTML += '<p class="nearby-dealer-address-address">〒' + tempDealer.zip + '<span>' + tempDealer.address + '</span></p>';
        nearbyDealerHTML += '<p class="nearby-dealer-tel"><svg xmlns="http://www.w3.org/2000/svg" width="12.975" height="12.975" viewBox="0 0 12.975 12.975" class="dealer-info-address-tel-icon"><path d="M12.975 9.673v2.549a.721.721 0 01-.67.719c-.315.022-.572.033-.771.033A11.533 11.533 0 010 1.442q0-.3.033-.771A.721.721 0 01.753 0H3.3a.361.361 0 01.359.324c.017.166.032.3.046.4a10.024 10.024 0 00.871 2.884.328.328 0 01-.106.409L2.916 5.126a9.4 9.4 0 004.933 4.933l1.11-1.553a.333.333 0 01.413-.107 10.022 10.022 0 002.883.869c.1.014.232.03.4.046a.36.36 0 01.324.359z"></path></svg>' 
        + tempDealer.tel + '</p>';
        nearbyDealerHTML += '</div>';
        nearbyDealerHTML += '<div class="nearby-dealer-dateinfo">';
        if ( tempDealer.notice ) {
          nearbyDealerHTML += '<p class="nearby-dealer-notice">' + tempDealer.notice + '<br>';
          nearbyDealerHTML += '営業時間' + tempDealer.businesshours + '</p>';
        } else {
          nearbyDealerHTML += '<p class="nearby-dealer-notice">営業時間 : ' + tempDealer.businesshours + '</p>';
        }
        nearbyDealerHTML += '</div>';
        nearbyDealerHTML += '</div>';

      }
      
    }
    $('.nearby-dealer-list').append(nearbyDealerHTML);
    $('.js-mapform-cb-dealer').prop('disabled', false);
    $('.js-mapform-cb-secondhandcar').prop('disabled', false);
    $('.js-mapform-cb-servicenetwork').prop('disabled', false);

    $('.js-mapform-prefectureslist').val(tempDealer.prefectures);
    map.panTo(new google.maps.LatLng(tempDealer.lat, tempDealer.lng));
    drop();
    map.setZoom(15);
  }


  // Search Address By Input

  $('#address_search').keypress(function (e) {
    if (e.which == 13) {
      searchNearbyDealerByInput();
  }
  });

  $('#search-current-location-btn').on('click', function() {
    if (myPosition) {
      searchNearby(myPosition);
    } else {
      $('.dealer-map-loading').fadeIn(400);
      navigator.geolocation.getCurrentPosition(
        // 取得成功した場合
        function (position) {
          myPosition = position;
          searchNearby(myPosition);
          $('.dealer-map-loading').fadeOut(400);
        },
        // 取得失敗した場合
        function (error) {
          $('.dealer-map-loading').fadeOut(400);
          $('.js-dealer-map-messagebox a').on('click', function () {
            $('.js-dealer-map-messagebox').fadeOut(400);
          });
          $('.js-dealer-map-messagebox').fadeIn(400);
          switch (error.code) {
            case 1: // PERMISSION_DENIED
              $('.js-dealer-map-messagebox span').html('位置情報の利用が許可されていません');
              break;
            case 2: // POSITION_UNAVAILABLE
              $('.js-dealer-map-messagebox span').html('現在位置が取得できませんでした');
              break;
            case 3: // TIMEOUT
              $('.js-dealer-map-messagebox span').html('タイムアウトになりました');
              break;
            default:
              $('.js-dealer-map-messagebox span').html('その他のエラー(エラーコード:' + error.code + ')');
              break;
          }
        }
      );
    }
  });

  $('#address_search').on('focus', function() {
    $('#search-current-location-btn').css('display', 'flex');
  });


  $(document).mouseup(function(e) {
    var container = $(".input-group");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('#search-current-location-btn').hide();
    }
  });

  $(document).ready(function() {
    displayCloseDealersOnInit();
  });

  function displayCloseDealersOnInit() {
    //console.log('lets goooo');
    var nearDist;
    var tempDealer;
    var nearbyDealerHTML = '';
    const closestDealers = [];
    var dealerCounter = 0;
    $('.nearby-dealer-list-subtitle').html('お近くのディーラー');
    $('.nearby-dealer-err-msg').html('');
    navigator.geolocation.getCurrentPosition(function(position) {
      var geocoder = new google.maps.Geocoder();
      var latLng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
      };
  
      geocoder.geocode({ 'location': latLng }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var address_lat = results[0].geometry.location.lat();
          var address_long =  results[0].geometry.location.lng();
          $('.nearby-dealer-list').html('');
          
          for (var i = 0; i < dealer_data.length; i++) {
            var tempDistance = measureDistance(address_lat, address_long, dealer_data[i].lat, dealer_data[i].lng);
            closestDealers.push(dealer_data[i]);
            closestDealers[i]['distance'] = tempDistance;
          }
          closestDealers.sort( function(a, b) {
            return a['distance'] - b['distance'];
          });
          for ( var i = 0; i < closestDealers.length; i++ ) {
            dealerCounter++;
            nearbyDealerHTML += '<div class="nearby-dealer-card">';
            nearbyDealerHTML += '<h1 class="nearby-dealer-name">' + closestDealers[i].name + '</h1>';
            nearbyDealerHTML += '<p class="nearby-dealer-company"><span class="km-box">' + closestDealers[i].distance.toFixed(2) + 'KM</span></p>';
            nearbyDealerHTML += '<div class="nearby-dealer-address">';
            nearbyDealerHTML += '<p class="nearby-dealer-address-address">〒' + closestDealers[i].zip + '<span>' + closestDealers[i].address + '</span></p>';
            nearbyDealerHTML += '<p class="nearby-dealer-tel"><svg xmlns="http://www.w3.org/2000/svg" width="12.975" height="12.975" viewBox="0 0 12.975 12.975" class="dealer-info-address-tel-icon"><path d="M12.975 9.673v2.549a.721.721 0 01-.67.719c-.315.022-.572.033-.771.033A11.533 11.533 0 010 1.442q0-.3.033-.771A.721.721 0 01.753 0H3.3a.361.361 0 01.359.324c.017.166.032.3.046.4a10.024 10.024 0 00.871 2.884.328.328 0 01-.106.409L2.916 5.126a9.4 9.4 0 004.933 4.933l1.11-1.553a.333.333 0 01.413-.107 10.022 10.022 0 002.883.869c.1.014.232.03.4.046a.36.36 0 01.324.359z"></path></svg>' 
            + closestDealers[i].tel + '</p>';
            nearbyDealerHTML += '</div>';
            nearbyDealerHTML += '<div class="nearby-dealer-dateinfo">';
            if( closestDealers[i].notice ) {
              nearbyDealerHTML += '<p class="nearby-dealer-notice">' + closestDealers[i].notice + '<br>';
              nearbyDealerHTML += '営業時間' + closestDealers[i].businesshours + '</p>';
            } else {
              nearbyDealerHTML += '<p class="nearby-dealer-notice">営業時間' + closestDealers[i].businesshours + '</p>';
            }
            nearbyDealerHTML += '</div>';
            nearbyDealerHTML += '</div>';
          }
          if (dealerCounter == 0) {
            nearbyDealerHTML += '<div class="nearby-dealer-err-msg">There are no nearby dealers.</div>';
          } else {
            $('.nearby-dealer-count').html(dealerCounter + " 店のアルファ ロメオ正規販売店が見つかりました。");
          }
          $('.nearby-dealer-list').html(nearbyDealerHTML);
      }
      return false;
      });

    }, function(error) {
        console.log("Error getting current position: " + error.message);
    });  
  }

  function searchNearbyDealerByInput() {
    navigator.geolocation.getCurrentPosition(function(position) {
      console.log(position);
    });  
    var nearDist;
    var tempDealer;
    var nearbyDealerHTML = '';
    const closestDealers = [];
    var dealerCounter = 0;
    var address = $('#address_search').val();
    $('.nearby-dealer-list-subtitle').html('お近くのディーラー');
    $('.nearby-dealer-err-msg').html('');
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode( { 'address': address}, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
            var address_lat = results[0].geometry.location.lat();
            var address_long =  results[0].geometry.location.lng();
            $('.nearby-dealer-list').html('');
            
            for (var i = 0; i < dealer_data.length; i++) {
              var tempDistance = measureDistance(address_lat, address_long, dealer_data[i].lat, dealer_data[i].lng);
              closestDealers.push(dealer_data[i]);
              closestDealers[i]['distance'] = tempDistance;
            }
            closestDealers.sort( function(a, b) {
              return a['distance'] - b['distance'];
            });
            for ( var i = 0; i < closestDealers.length; i++ ) {
              if ( closestDealers[i].distance <= 100) {
                dealerCounter++;
                nearbyDealerHTML += '<div class="nearby-dealer-card">';
                nearbyDealerHTML += '<h1 class="nearby-dealer-name">' + closestDealers[i].name + '</h1>';
                nearbyDealerHTML += '<p class="nearby-dealer-company"><span class="km-box">' + closestDealers[i].distance.toFixed(2) + 'KM</span></p>';
                nearbyDealerHTML += '<div class="nearby-dealer-address">';
                nearbyDealerHTML += '<p class="nearby-dealer-address-address">〒' + closestDealers[i].zip + '<span>' + closestDealers[i].address + '</span></p>';
                nearbyDealerHTML += '<p class="nearby-dealer-tel"><svg xmlns="http://www.w3.org/2000/svg" width="12.975" height="12.975" viewBox="0 0 12.975 12.975" class="dealer-info-address-tel-icon"><path d="M12.975 9.673v2.549a.721.721 0 01-.67.719c-.315.022-.572.033-.771.033A11.533 11.533 0 010 1.442q0-.3.033-.771A.721.721 0 01.753 0H3.3a.361.361 0 01.359.324c.017.166.032.3.046.4a10.024 10.024 0 00.871 2.884.328.328 0 01-.106.409L2.916 5.126a9.4 9.4 0 004.933 4.933l1.11-1.553a.333.333 0 01.413-.107 10.022 10.022 0 002.883.869c.1.014.232.03.4.046a.36.36 0 01.324.359z"></path></svg>' 
                + closestDealers[i].tel + '</p>';
                nearbyDealerHTML += '</div>';
                nearbyDealerHTML += '<div class="nearby-dealer-dateinfo">';
                if( closestDealers[i].notice ) {
                  nearbyDealerHTML += '<p class="nearby-dealer-notice">' + closestDealers[i].notice + '<br>';
                  nearbyDealerHTML += '営業時間' + closestDealers[i].businesshours + '</p>';
                } else {
                  nearbyDealerHTML += '<p class="nearby-dealer-notice">営業時間' + closestDealers[i].businesshours + '</p>';
                }
                nearbyDealerHTML += '</div>';
                nearbyDealerHTML += '</div>';
              }
            }
            if (dealerCounter == 0) {
              nearbyDealerHTML += '<div class="nearby-dealer-err-msg">There are no nearby dealers.</div>';
            } else {
              $('.nearby-dealer-count').html(dealerCounter + " 店のアルファ ロメオ正規販売店が見つかりました。");
            }
            $('.nearby-dealer-list').html(nearbyDealerHTML);
        }
      searchAddress(address);
      drop();
      return false;
    });

  }


  function measureDistance(lat1, lon1, lat2, lon2) {
    var radlat1 = Math.PI * lat1/180;
    var radlat2 = Math.PI * lat2/180;
    var theta = lon1-lon2;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344;
    return dist
  }

  // 住所クリック
  function searchAddress (address) {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({
      'address': address
    }, function (result, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        map.panTo(result[0].geometry.location);
        map.setZoom(14);
      }
    });
  }
  $(document).on('click', '.dealer-list-dealer-address-address a, .dealer-list-servicenetwork-address-address a', function () {
    searchAddress($('span', this).html());
    $('html, body').animate({
      scrollTop: 0
    }, 400, 'swing');
    return false;
  });

  $(document).on('click', '.nearby-dealer-card', function () {
    var span = $('.nearby-dealer-address-address span', this).html();
    searchAddress(span);
    $('html, body').animate({
      scrollTop: 0
    }, 400, 'swing');
    return false;
  });

  // マップインフォリンク拡大
  $(document).on('mouseover', '.js-dealer-info-cover', function () {
    if ($('a', '.js-dealer-info-cover')[0]) {
      $(this).find('a').addClass('is-hover');
    }
  });
  $(document).on('mouseleave', '.js-dealer-info-cover', function () {
    if ($('a', '.js-dealer-info-cover')[0]) {
      $(this).find('a').removeClass('is-hover');
    }
  });
  $(document).on('click', '.js-dealer-info-cover', function () {
    if ($('a', '.js-dealer-info-cover')[0]) {
      window.open($(this).find('a').attr('href'));
    }
  });
});
